import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import sharedReducer from './slice';
import headerReducer from 'src/features/header/store/slice';
import navReducer from 'src/features/nav/store/slice';
import footerReducer from 'src/features/footer/store/slice';

export const rootReducer = combineReducers({
  shared: sharedReducer,
  header: headerReducer,
  nav: navReducer,
  footer: footerReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
